import { render, staticRenderFns } from "./VesselStatus.vue?vue&type=template&id=24ec46fa&"
import script from "./VesselStatus.vue?vue&type=script&lang=js&"
export * from "./VesselStatus.vue?vue&type=script&lang=js&"
import style0 from "./VesselStatus.vue?vue&type=style&index=0&id=24ec46fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports